/**
 * Utilitaire pour gérer la redirection selon le rôle de l'utilisateur
 */

/**
 * Retourne la route de redirection par défaut selon le rôle
 * @param {string} roleName - Nom du rôle (AdminPanel, AdminRH, AdminRH+1, Employee)
 * @returns {string} - Route de redirection
 */
export const getDefaultRouteForRole = (roleName) => {
  if (!roleName) return '/login';

  switch (roleName.toLowerCase()) {
    case 'adminpanel':
      return '/adminpanel';
    
    case 'adminrh':
    case 'adminrh+1':
      return '/dashboard';
    
    case 'employee':
      return '/employeeDashboard';
    
    default:
      return '/login';
  }
};

/**
 * Vérifie si l'utilisateur a accès à une route donnée
 * @param {string} roleName - Nom du rôle
 * @param {string} route - Route à vérifier
 * @returns {boolean} - true si l'utilisateur a accès
 */
export const hasAccessToRoute = (roleName, route) => {
  if (!roleName || !route) return false;

  const role = roleName.toLowerCase();

  // Routes AdminPanel
  if (route.startsWith('/adminpanel')) {
    return role === 'adminpanel';
  }

  // Routes AdminRH et AdminRH+1
  const adminRHRoutes = [
    '/dashboard',
    '/employes',
    '/pointages',
    '/departements',
    '/horaires',
    '/conges',
    '/parametres',
    '/confidentialite',
    '/cartes-employes'
  ];

  if (adminRHRoutes.some(r => route.startsWith(r))) {
    return role === 'adminrh' || role === 'adminrh+1';
  }

  // Routes Employee
  const employeeRoutes = [
    '/home-employee',
    '/pointageEntree',
    '/pointageSortie',
    '/pointageEnregistree',
    '/carte',
    '/login-webauthn',
    '/register-employee',
    '/password-fallback',
    '/reset-password-employee'
  ];

  if (employeeRoutes.some(r => route.startsWith(r))) {
    return role === 'employee';
  }

  return false;
};

/**
 * Liste des routes publiques accessibles sans authentification
 */
export const publicRoutes = [
  '/login',
  '/register',
  '/reset-password',
  '/activate-account'
];

/**
 * Vérifie si une route est publique
 * @param {string} route - Route à vérifier
 * @returns {boolean} - true si la route est publique
 */
export const isPublicRoute = (route) => {
  return publicRoutes.some(r => route.startsWith(r));
};











































